import * as _ from 'lodash'
import {
  ISearch,
  ISearchProfile,
  ISearchProvider,
  HorizAlignment,
  SearchProviderFieldType,
  ISearchProviderField, ISearchRequestSubset, IProfileFilter, ITree, ISearchSort, ISearchRenderOptions
} from "../PA.UIM.Core/PA.UIM.Core.IF.Search"
import {ColumnNodeProvider} from "../PA.UIM.Core/SearchTreeUtils";
import {PAdbContext} from "../PA.Core/PAdbContext";
import {esWB_Metric_Definition} from "../PA.Core/PAdbSchema";
import {WB_MetricDefinitionRow} from "../PA.Core/PAdbSchemaRows";


export interface IMetricDefinitionSearchByListCreateOptions {
  sName: string,
  metricDefinitions?: WB_MetricDefinitionRow[],
  subjectAreaId?: number
}

const vUI_Metric_Definition_Search_Fields: {[id:string]: ISearchProviderField } = {

  WB_MTRDFN_ID:           {type: SearchProviderFieldType.number, renderOptions: { columnName: 'WB Metric Id', columnResourceName: 'colId', alignment: HorizAlignment.Center}, domainOptions: {}},
  METRIC_ID:            {type: SearchProviderFieldType.string, renderOptions: { columnName: 'Metric Id', columnResourceName: 'colId', alignment: HorizAlignment.Left}, domainOptions: { maxLength: 50}},
  METRIC_NAME:          {type: SearchProviderFieldType.string, renderOptions: { columnName: 'Metric Name', columnResourceName: 'colName', alignment: HorizAlignment.Left}, domainOptions: { maxLength: 256}},
  METRIC_DATATYPE:       {type: SearchProviderFieldType.string, renderOptions: { columnName: 'Metric DataType', columnResourceName: 'colEventTypeID', alignment: HorizAlignment.Right}, domainOptions: {maxLength: 20}},
  METRIC_USAGE:  {type: SearchProviderFieldType.string, renderOptions: { columnName: 'Metric Usage', columnResourceName: 'colWorkFlowStatus', alignment: HorizAlignment.Right}, domainOptions: {maxLength: 50}},
  EDITABLE_IND:    {type: SearchProviderFieldType.boolean, renderOptions: { columnName: 'Editable Ind', columnResourceName: 'colPlanningCustomer', alignment: HorizAlignment.Left}, domainOptions: { maxLength: 1}},
  MINVALUE: {type: SearchProviderFieldType.number, renderOptions: { columnName: 'Minimum Value', columnResourceName: 'colSubPlanningCustomer', alignment: HorizAlignment.Left}, domainOptions: {}},
  MAXVALUE:    {type: SearchProviderFieldType.number, renderOptions: { columnName: 'Maximum Value', columnResourceName: 'colInStoreStart', alignment: HorizAlignment.Center}, domainOptions: {}},
  COPYPOLICY:      {type: SearchProviderFieldType.string, renderOptions: { columnName: 'Copy policy', columnResourceName: 'colInStoreEnd', alignment: HorizAlignment.Center}, domainOptions: {maxLength: 1}},
  FORMULA:   {type: SearchProviderFieldType.string, renderOptions: { columnName: 'Formula', columnResourceName: 'colShipmentStart', alignment: HorizAlignment.Center}, domainOptions: {maxLength: 100}},
  TOTALPOLICY:     {type: SearchProviderFieldType.string, renderOptions: { columnName: 'Total Policy', columnResourceName: 'colShipmentEnd', alignment: HorizAlignment.Center}, domainOptions: {maxLength: 1}},
  TOTAL_FORMULA:     {type: SearchProviderFieldType.string, renderOptions: { columnName: 'Total Formula', columnResourceName: 'colShipmentEnd', alignment: HorizAlignment.Center}, domainOptions: {maxLength: 256}},
  RECORD_PROPERTIES:     {type: SearchProviderFieldType.string, renderOptions: { columnName: 'Record Properties', columnResourceName: 'colShipmentEnd', alignment: HorizAlignment.Center}, domainOptions: {maxLength: 256}},
  TOTAL_AGGREGATION_TERMS:     {type: SearchProviderFieldType.string, renderOptions: { columnName: 'Total Aggregation Terms', columnResourceName: 'colShipmentEnd', alignment: HorizAlignment.Center}, domainOptions: {maxLength: 1333}},
  METRIC_FORMAT:     {type: SearchProviderFieldType.string, renderOptions: { columnName: 'Metric Format', columnResourceName: 'colShipmentEnd', alignment: HorizAlignment.Center}, domainOptions: {maxLength: 1333}},
  OPTIONS:     {type: SearchProviderFieldType.string, renderOptions: { columnName: 'Option', columnResourceName: 'colShipmentEnd', alignment: HorizAlignment.Center}, domainOptions: {maxLength: 256}},
  METRIC_TYPE: {type: SearchProviderFieldType.string, renderOptions: { columnName: 'Metric Type', columnResourceName: 'colMtrType', alignment: HorizAlignment.Right}, domainOptions: {maxLength: 50}},
  WB_SUBJECTAREA_ID: {type: SearchProviderFieldType.number, renderOptions: { columnName: 'Subject Area ID', columnResourceName: 'colSubjAreaID', alignment: HorizAlignment.Right}, domainOptions: {}},
  SUBJECTAREA_COLUMNNAME: {type: SearchProviderFieldType.string, renderOptions: { columnName: 'Subject Area Name', columnResourceName: 'colSubjAreaName', alignment: HorizAlignment.Right}, domainOptions: {maxLength: 50}},
  CURRENCY_IND: {type: SearchProviderFieldType.boolean, renderOptions: { columnName: 'Currency Ind', columnResourceName: 'colCurInd', alignment: HorizAlignment.Right}, domainOptions: {}},
  FILTER_OPTIONS: {type: SearchProviderFieldType.string, renderOptions: { columnName: 'Filter Options', columnResourceName: 'colFltrOpts', alignment: HorizAlignment.Right}, domainOptions: {maxLength: 1333}},
  GL_ACCOUNT_FILTER_IND: {type: SearchProviderFieldType.boolean, renderOptions: { columnName: 'GL Account Filter Ind', columnResourceName: 'colGLAcct', alignment: HorizAlignment.Right}, domainOptions: {}}
}


const   MetricDefinition_keyFields_ByWBId =
  {  id:       'WB_MTRDFN_ID',
    id_ui:     'METRIC_ID',
    name:      'METRIC_NAME'
  }



class MetricDefinitionSearchByListSearchProvider
  implements  ISearchProvider {

  opts: IMetricDefinitionSearchByListCreateOptions

  constructor(options: IMetricDefinitionSearchByListCreateOptions){
    this.opts = options || {sName: "Unknown"}
  }

  get keyFields() {
    return MetricDefinition_keyFields_ByWBId
  }

  get searchProviderFields(){
    return vUI_Metric_Definition_Search_Fields
  }

  search(requestSpec: ISearchRequestSubset): Promise<any[]> {
    const self = this

    return new Promise<any[]>((resolve, error) => {

      if(!_.isEmpty(self.opts.metricDefinitions)){
        resolve(self.opts.metricDefinitions)
        return
      }

      let subjectAreaId = self.opts.subjectAreaId || 0

      if(!subjectAreaId){
        resolve([])
        return
      }

      let aDbContext = new PAdbContext()
      aDbContext.findAll(esWB_Metric_Definition, {where: {WB_SUBJECTAREA_ID: subjectAreaId, DELETED_IND: {neq: ['1']}} })
        .then((arrMetricDefinitions: WB_MetricDefinitionRow[]) => {
          let results = _.sortBy(arrMetricDefinitions, ['METRIC_NAME','METRIC_ID'])
          resolve(results)
        })
        .catch((err) => {
          error(err)
        })
    })
  }

}


export class MetricDefinitionSearchProfileByList
  implements  ISearchProfile {

  aSearchProvider: ISearchProvider = undefined

  profileId = "default"
  profileName = "AutoSearch Only"
  renderOptions = { ui5ResourceId: "MetricDefinitionSearchByListProfile" }

  profileFilter: IProfileFilter[] = []

  profileDisplayFields = [
    'METRIC_NAME','METRIC_ID'
  ]

  profileTreeIdDefault = ""
  profileTrees: ITree[] = []

  profileSortIdDefault = ""    //string;
  profileSorts: ISearchSort[] = [] //ISearchSort[];


  constructor(options: IMetricDefinitionSearchByListCreateOptions){
    this.aSearchProvider = new MetricDefinitionSearchByListSearchProvider(options)
  }

  get profileSearchProvider(){ return this.aSearchProvider }

}


export class MetricDefinitionSearchByList
  implements  ISearch {

  opts: IMetricDefinitionSearchByListCreateOptions
  autoSearch: boolean;
  autoSearchProfileId: string;
  renderOptions: ISearchRenderOptions;
  searchName: string;
  searchProfileIdDefault: string;
  searchProfiles: ISearchProfile[];

  constructor(options: IMetricDefinitionSearchByListCreateOptions){
    this.opts = options || {sName: "Select"}
    this.searchName = this.opts.sName
    this.renderOptions = { ui5ResourceId: "MetricDefinitionSearchByList"}
    this.searchProfileIdDefault = "default"
    this.searchProfiles = []
    this.autoSearch = true

    this.searchProfiles = [ new MetricDefinitionSearchProfileByList(this.opts) ]
  }

}

